import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { HttpInterceptorFn } from '@angular/common/http';
import { provideRouter, Router, Scroll } from '@angular/router';
import { routes } from './app.routes';
import { inject, ENVIRONMENT_INITIALIZER } from '@angular/core';
import { TokenService } from './services/token.service';
import { EnvironmentService } from './services/environment.service';
import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs/operators';

// Custom ErrorHandler um Detection-Fehler zu supprimieren
class BackendDetectionErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // Supprimiere 404 Fehler von Backend Detection
    if (error?.message?.includes('404') || error?.status === 404) {
      return; // Fehler ignorieren
    }
    // Alle anderen Fehler normal loggen
    console.error(error);
  }
}

const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const envService = inject(EnvironmentService);
  const token = tokenService.getToken();

  // Nur bei Backend-Requests Token hinzufügen
  try {
    const apiUrl = envService.getApiUrl();
    if (token && req.url.includes(apiUrl)) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  } catch (e) {
    console.warn('API URL not yet detected, skipping JWT injection');
  }

  return next(req);
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([jwtInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: (envService: EnvironmentService) => () =>
        envService.detectBackendUrl(),
      deps: [EnvironmentService],
      multi: true
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        const router = inject(Router);
        const viewportScroller = inject(ViewportScroller);

        router.events.pipe(
          filter((e): e is Scroll => e instanceof Scroll)
        ).subscribe(() => {
          viewportScroller.scrollToPosition([0, 0]);
        });
      }
    }
  ]
};
